import { SubscriptionPlanUsageResponse } from "../../api-models/response/SubscriptionPlanUsageResponse";

export class SubscriptionPlanUsage {
  hasPaidSubscription: boolean;
  totalFullRightsSeats: number;
  usedFullRightsSeats: number;
  totalGuestSeats: number;
  usedGuestSeats: number;
  totalStorageSpace: number;
  usedStorageSpace: number;
  totalVideoAnalysisCalls: number;
  usedVideoAnalysisCalls: number;

  constructor(subscriptionPlanUsageResponse?: SubscriptionPlanUsageResponse) {
    if (subscriptionPlanUsageResponse) {
      this.hasPaidSubscription = subscriptionPlanUsageResponse.hasPaidSubscription;
      this.totalFullRightsSeats = subscriptionPlanUsageResponse.totalFullRightsSeats;
      this.usedFullRightsSeats = subscriptionPlanUsageResponse.usedFullRightsSeats;
      this.totalGuestSeats = subscriptionPlanUsageResponse.totalGuestSeats;
      this.usedGuestSeats = subscriptionPlanUsageResponse.usedGuestSeats;
      this.totalStorageSpace = subscriptionPlanUsageResponse.totalStorageSpace;
      this.usedStorageSpace = subscriptionPlanUsageResponse.usedStorageSpace;
      this.totalVideoAnalysisCalls = subscriptionPlanUsageResponse.totalVideoAnalysisCalls;
      this.usedVideoAnalysisCalls = subscriptionPlanUsageResponse.usedVideoAnalysisCalls;
    } else {
      this.hasPaidSubscription = false;
      this.totalFullRightsSeats = 0;
      this.usedFullRightsSeats = 0;
      this.totalGuestSeats = 0;
      this.usedGuestSeats = 0;
      this.totalStorageSpace = 0;
      this.usedStorageSpace = 0;
      this.totalVideoAnalysisCalls = 0;
      this.usedVideoAnalysisCalls = 0;
    }
  }
}
